interface State {
  page_size?: number
  department?: string
  q?: string
  sort_by?: string
  page: number
  [key: string]: any
}

interface BaseAction {
  queryType?: string
  [key: string]: any
}

interface DeleteAction extends BaseAction {
  queryType: 'delete'
  queries?: string[]
  query?: string
}

interface ResetAction extends BaseAction {
  queryType: 'reset'
  queries: Record<string, any>
}

interface DepartmentAction extends BaseAction {
  queryType: 'department'
  department?: string
}

interface IncreasePageAction extends BaseAction {
  queryType: 'increase_page'
}

interface DefaultAction extends BaseAction {
  deleteQueries?: string[]
}

type Action =
  | DeleteAction
  | ResetAction
  | DepartmentAction
  | IncreasePageAction
  | DefaultAction

export const queriesReducer = (state: State, action: Action): State => {
  if (!action.queryType) {
    if (action.deleteQueries && Array.isArray(action.deleteQueries)) {
      const newState = { ...state }
      for (const q of action.deleteQueries) delete newState[q]
      delete action.deleteQueries
      return { ...newState, ...action }
    }
    return { ...state, ...action }
  } else if (action.queryType === 'delete') {
    const newState = { ...state }
    if (action.queries && Array.isArray(action.queries)) {
      for (const q of action.queries) delete newState[q]
    }
    if (action.query) delete newState[action.query]
    return { ...newState }
  } else if (action.queryType === 'reset')
    return {
      ...(state.page_size && { page_size: state.page_size }),
      ...(state.department && { department: state.department }),
      ...(state.q && { q: state.q }),
      ...(state.sort_by && { sort_by: state.sort_by }),
      ...action.queries
    }
  else if (action.queryType === 'department') {
    if (!action.department) delete state.department
    return {
      ...state,
      ...(action.department && { department: action.department })
    }
  } else if (action.queryType === 'increase_page') {
    return { ...state, page: state.page + 1 }
  }

  return state
}
